import { OnbaseEconomicActivity } from "./onbase-economic-activity"

export class OnbaseCatalogue {
    legalRelation: { [key: string]: string; };
    naturalRelation: { [key: string]: string };
    maritalStatus: { [key: string]: string };
    academicTitle: { [key: string]: string };
    economicActivityPeriod: { [key: string]: string };
    occupation: { [key: string]: string };
    loanType: { [key: string]: string };
    companySize: { [key: string]: string };
    business: { [key: string]: string };
    economicActivity: Array<OnbaseEconomicActivity>;
    homeType: { [key: string]: string };
    relationType: { [key: string]: string };
    businessPosition: { [key: string]: string };
    stateOnBase: { [key: string]: string };
    origin: { [key: string]: string };

    constructor() {
        this.legalRelation = {};
        this.naturalRelation = {};
        this.maritalStatus = {};
        this.academicTitle = {};
        this.economicActivityPeriod = {};
        this.occupation = {};
        this.loanType = {};
        this.companySize = {};
        this.business = {};
        this.economicActivity = [];
        this.homeType = {};
        this.relationType = {};
        this.businessPosition = {};
        this.stateOnBase = {};
        this.origin = {};
    }
}